"use client";

import type { CatalogItem } from "@/lib/airtable";
import { FilteredCatalogClient } from "./FilteredCatalogClient";

type Props = {
  items: CatalogItem[];
};

export default function BrowseContentClient({ items }: Props) {
  // The swipe-deck promo popup now lives site-wide (see SwipeDeckPromoModal in
  // the root layout), so the browse page no longer shows its own popup.
  return <FilteredCatalogClient items={items} showPieceFilter backHref="/browse" backLabel="Browse" />;
}
